import React, { createContext, useState } from "react";
import dayjs from "dayjs";

export const SearchContext = createContext();

export default function HotelRoomSearchProvider({ children }) {

  // Defining Dates
  const checkinDef = dayjs();
  const checkoutDef = checkinDef.add(4, "day");

  const [searchValues, setSearchValues] = useState({
    location: "banff canada",
    checkin: `${checkinDef.$y}-${checkinDef.$M + 1}-${checkinDef.$D}`,
    checkout: `${checkoutDef.$y}-${checkoutDef.$M + 1}-${checkoutDef.$D}`,
    counter: {
      rooms: 1,
      adults: 2,
      children: 0,
    },
  });

  return (
    <SearchContext.Provider value={{ searchValues, setSearchValues }}>
      {children}
    </SearchContext.Provider>
  );
}